import PropTypes, { bool } from "prop-types";
import { CustomContainer } from "../../atoms/DependencyHelper";
import CheckoutNav from "../../molecules/checkoutNav/CheckoutNav";
import CheckoutFaq from "../../molecules/checkoutFaq/CheckoutFaq";
import CheckoutFooter from "../../molecules/checkoutFooter/CheckoutFooter";
import MainContainer from "../../atoms/container/MainContainer";
import { MobileCheckoutStepper } from "../../molecules/checkoutStepper/CheckoutStepper";
import ErrorTooltip from "../../molecules/errorToolTip/ErrorTooltip";
import styles from "./CheckoutPage.module.scss";
import * as Analytics from "../../../services/analyticsUtag";

const CheckoutPage = ({
  children,
  steps = [],
  stepsShow,
  stepsWidth,
  activeStep,
  activeStepNo,
  className,
  customerStatus,
  orderSummeryVariant,
  faq,
  showSnackBar,
  setShowSnackBar,
  multicartFlag,
}) => {
  const displayMobileStepper =
    activeStepNo + 1 > 0 && activeStepNo <= steps.length;

  const closeSnackBar = () => {
    if (activeStep == "otp") {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: `checkout: authentication: ${customerStatus}: dismiss`,
        ...getUtagViewData(),
      });
    }
    setShowSnackBar({
      visible: false,
      message: "",
      type: "default",
      className: "",
      dismissClass: "",
      textClass: "",
    });
  };

  const getUtagViewData = () => {
    return Analytics.getUtagData([
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_login_status",
      "visitor_subscription_type",
      "visitor_msisdn_hash",
      "page_name",
      "page_channel",
      "page_master_tab",
    ]);
  };

  return (
    <CustomContainer className={styles["main-wrapper"]}>
      <CheckoutNav
        steps={steps}
        stepsShow={stepsShow}
        stepsWidth={stepsWidth}
        activeStep={activeStep}
        activeStepNo={activeStepNo}
        customerStatus={customerStatus}
        multicartFlag={multicartFlag}
      />
      <CustomContainer
        className={`${styles["content-wrapper"]} ${
          activeStep == "orderConfirmation"
            ? styles["success"]
            : activeStep == "pageError" ||
              activeStep == "paymentError" ||
              activeStep == "paymentRedirect"
            ? "justify-content-center"
            : ""
        }`}
      >
        <MainContainer
          className={styles["main"]}
          paddingTop="4.5rem"
          mdPaddingTop="6rem"
          lgPaddingTop="6rem"
        >
          {showSnackBar.visible && (
            <ErrorTooltip
              errorMsg={showSnackBar.message}
              buttonHandler={closeSnackBar}
              type={showSnackBar.type}
              className={`${styles["error-tooltip"]} ${showSnackBar.className}`}
              dismissClass={showSnackBar.dismissClass}
              textClass={showSnackBar.textClass}
              showAnalytics={false}
            />
          )}
          {displayMobileStepper && stepsShow && (
            <MobileCheckoutStepper
              steps={steps}
              stepsShow={stepsShow}
              activeStepNo={activeStepNo}
            />
          )}

          <CustomContainer
            className={`${styles["center-container"]} ${className}`}
          >
            {children}
          </CustomContainer>
        </MainContainer>
        {faq && <CheckoutFaq faq={faq} customerStatus={customerStatus} />}
      </CustomContainer>
      <CheckoutFooter orderSummeryVariant={orderSummeryVariant} />
    </CustomContainer>
  );
};

CheckoutPage.defaultProps = {
  stepsShow: false,
  faq: null,
  stepsWidth: "step-width-65",
};

CheckoutPage.propTypes = {
  children: PropTypes.node,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  stepsShow: bool,
  activeStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default CheckoutPage;
